module.exports = __webpack_public_path__ + "img/icon_map_10_on_110.ad589893.png";